const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-8"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.93 146.31 285.09 109.55 285 109.46 227.5 50.52 181.38 92.64 180.71 91.9 227.54 49.13 285.63 108.67 393.55 145.12 437.85 84.19 438.66 84.78 393.93 146.31",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.61,236.79a5.38,5.38,0,1,1-5.38-5.38A5.38,5.38,0,0,1,55.61,236.79Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,49.82a5.38,5.38,0,1,1-5.38-5.38A5.38,5.38,0,0,1,232.9,49.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.63,84.48a5.38,5.38,0,1,1-5.38-5.38A5.38,5.38,0,0,1,443.63,84.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.1,368.38a5.38,5.38,0,1,1-5.38-5.38A5.38,5.38,0,0,1,444.1,368.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.74,109.11a5.38,5.38,0,1,1-5.38-5.38A5.38,5.38,0,0,1,290.74,109.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.35 368.52 190.94 368.44 56.02 342.97 56.2 341.99 190.71 367.38 284.89 108.94 285.83 109.28 191.35 368.52",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.66,
    y: 122.93,
    width: 1,
    height: 61.49,
    transform: "translate(-86.34 115.55) rotate(-48.47)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.46 368.81 371.75 327.47 373.21 327.07 443.29 259.65 393.28 145.92 394.2 145.51 444.49 259.88 444.24 260.13 374.01 327.69 438.98 367.96 438.46 368.81",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.53 342.75 55.69 342.2 96.01 279.93 49.53 236.81 49.87 236.45 108.08 173.42 108.43 173.62 373.71 327.09 373.21 327.95 108.27 174.69 50.94 236.76 97.3 279.77 56.53 342.75",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-8",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--World--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241,299.13q4,.33,8,.27a81.27,81.27,0,0,0,79.72-74.58c0-.5.08-1,.11-1.48A81.08,81.08,0,0,0,325.36,194h0a81.38,81.38,0,0,0-62.71-55.82c-2.71-.49-5.46-.87-8.25-1.1a81.17,81.17,0,0,0-68,27.57A81.28,81.28,0,0,0,241,299.13Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241,299.13q4,.33,8,.27a81.27,81.27,0,0,0,79.72-74.58c0-.5.08-1,.11-1.48A81.08,81.08,0,0,0,325.36,194h0a81.38,81.38,0,0,0-62.71-55.82c-2.71-.49-5.46-.87-8.25-1.1a81.17,81.17,0,0,0-68,27.57A81.28,81.28,0,0,0,241,299.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.82,237.94c-.27,1.51-2.19,2.06-3.74,2.25l-7,.87c-1.1-2.89-4.52-2.91-6.92-1.79A81.31,81.31,0,0,0,241,299.13q4,.33,8,.27a1.37,1.37,0,0,0,.13-.2c1.22-2.13-.54-4-1.48-5.76-.21-.39-2.21-5.43-1.55-5.44a21.89,21.89,0,0,1-6.33-.82.66.66,0,0,1-.4-.24c-.2-.34.27-.66.64-.75,1-.22,1.95-.28,2.89-.56a3.33,3.33,0,0,0,2.24-1.76c.37-.92.09-2,.3-2.94a4,4,0,0,1,2.31-2.62,13,13,0,0,1,3.35-.9c-2.45-1.34-.66-4.12-2.59-6-.62-.59-1.52-1.32-1.14-2.1s1.66-.72,1.82-1.52c.11-.56-.48-1-1-1.15a6.3,6.3,0,0,1-1.67-.36,1.5,1.5,0,0,1-.47-2.09c.42-.59,1.2-.77,1.84-1.11s1.21-1.12.83-1.74a1.2,1.2,0,0,0-.37-.34c-1-.65-2.41-.11-3.42.57s-2,1.54-3.27,1.53a1,1,0,0,1,.4-1.38,1.91,1.91,0,0,0,.49-.26c.29-.29.08-.77-.12-1.13a7.33,7.33,0,0,1-.56-5.58l7.44.14c.06-.56.12-.89.72-1.06-1.67-2-3.48-3.84-5-6a1.46,1.46,0,0,0-.66-.64,4.54,4.54,0,0,0-1,0c-1.07-.15-1.24-1.62-1.13-2.69-.16-.33-.68-.19-.88.11s-.25.69-.49,1a1.35,1.35,0,0,1-1.5.16,3.56,3.56,0,0,1-1.89-4.63,1,1,0,0,1,.4-.52c.43-.24.94.06,1.42.14,1.9.34,1.61-1.75,1.16-2.75-.62-1.34-2.47-2.21-3.81-2.55-1.57-.41-12-2.41-10.32-5.82a1.59,1.59,0,0,1,.81-.68,24.11,24.11,0,0,1,3.2-.61c1-.29,2.06-1.38,1.6-2.37-.18-.4-.56-.67-.77-1.05-.59-1.07.32-2.45-.1-3.59a9.55,9.55,0,0,0-.92-1.39c-.28-.49-.33-1.22.15-1.51s1.27.16,1.84-.1a1,1,0,0,0,0-1.62,1.69,1.69,0,0,0-1.85.14,2.18,2.18,0,0,1-.89.49c-.61.08-1.07-.52-1.38-1.06l-1.49-2.53a1.43,1.43,0,0,0-1.18,1c-.19.52-.23,1.1-.44,1.62-1.06,2.51-4.87,2.21-4.38,5.64a1.64,1.64,0,0,1,1.66,2c-.4,1.22-2.22,1.88-2,3.13.09.44.44.79.51,1.23.19,1.21-1.68,1.66-2.49,1.93-2.67.92-2.85-.83-5.16-.94-1.06,0-2,.67-3.06.79s-1.93-.31-2.91-.25c-2.67.15-1.33,3.78-1.14,5.36-1.44-1-3.36.16-4.5,1.45-1.76,2-1.59,1.63-3.92,1.71a1.72,1.72,0,0,0-1.51.89c-.43,1,.49,2,.52,3.1,0,.52-.19,1-.15,1.53.13,1.35,1.72,1.93,2.68,2.87a3.68,3.68,0,0,1,1,3.24,7.85,7.85,0,0,1-2-.15l-1.21-2.33a4.92,4.92,0,0,0-1.36-1.85,4.44,4.44,0,0,1-1-.78c-.5-.7-.09-1.65,0-2.51.29-2.07-.75-5.55-1.26-7.6s-2-3.05-2.52-5.07a.64.64,0,0,0-.91-.29,1.38,1.38,0,0,0-.57.91,3.72,3.72,0,0,0,.22,2.5c-.47-1-3,1.66-3.2,2.17-.26.84.3,2,.27,2.89-.05,2.16-.57,3.36-2.79,1.78-.85-.6-1.94-1.32-2.84-.79a1.35,1.35,0,0,1-.75,1.52,2.87,2.87,0,0,1-1.81.14,1.78,1.78,0,0,1-1.09-.54,3,3,0,0,0-.4-.52c-.57-.45-1.29.32-1.6,1",
    style: {
      fill: "#D2232A",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,174c.45.71,0,1.62-.54,2.28s-1.11,1.44-.89,2.24l2.9.27a.51.51,0,0,1,.57.71c-.07.62-.15,1.24-.22,1.86-.61.48-1.2-1-2-.87-.33.07-.5.43-.69.71-1.56,2.46-4.3.62-5.76-.66-1.7-1.48-4.16-1.57-6.41-1.6a3,3,0,0,0-2.28.6c-.56.56-.59,1.44-.87,2.19-.49,1.3-1.73,2.15-2.44,3.34-2.46,4.17,2,7.38,5.73,6.24,1.95-.58,1.61-.93,3.6-.35.83.24,1.85,0,2.36,1a1.55,1.55,0,0,1-1.35,2.26,6.56,6.56,0,0,1-3.21-.37c.38,1.32,0,2.82-.14,4.22a1.84,1.84,0,0,0-2,2.46c.63,0,1.49.25,1.44.88a1.22,1.22,0,0,1-.22.51,20.91,20.91,0,0,0-1.39,1.86c-.59,1-.58,4.15-2.07,4.52-.26.07-.54,0-.8.13a1.19,1.19,0,0,0-.73,1.39,1.64,1.64,0,0,0,1.18,1.14c.37.1.77.09,1.13.21,1.92.67.23,2.57.69,3.51a17.32,17.32,0,0,0,3.84,2.55,4.55,4.55,0,0,0-2.17,3.42c0,1.56,1.15,2.32,2.63,2.79s3.48.65,4.61,1.09c.61.23,1.35.45,1.86.05s.5-1.7,1.24-2.05a2.16,2.16,0,0,1,.76-.12,2.87,2.87,0,0,0,2.45-3.23c.35-.45,1-.41,1.61-.39s1.3-.18,1.38-.75-.74-1-1.4-1a7.16,7.16,0,0,0-2,.16,2.33,2.33,0,0,1-1.47.06,2,2,0,0,1-.78-.81,4.42,4.42,0,0,1-.82-2.58,1.89,1.89,0,0,1,1.73-1.79,3.64,3.64,0,0,0,.73.05c.63-.1.9-.87.86-1.5a5.69,5.69,0,0,1-.08-1.88c.17-.61,1-1.06,1.44-.59.35-.8.58-2-.21-2.37a2.3,2.3,0,0,0-.83-.14c-1.74-.17-4.09-2.52-2.15-3.86,1.27-.88,3.32,1,4.43-.71.54-.8.21-2,.76-2.75.32-.23.7.24.77.64a3.72,3.72,0,0,1-1.21,3.42c1,.57,2.52-.08,3.19.83s-.32,2.48.55,3.18a1.73,1.73,0,0,0,.89.31c1.57.23,4.49,0,4.58,2.2a3.64,3.64,0,0,0,.05.81c.24.79,1.32.87,2.14.78.42-.8-.13-1.74-.5-2.58s-.33-2.11.55-2.32c.64-.15,1.38.4,1.91,0,.25-.17.36-.5.63-.64.65-.34,1.19.65,1.89.87,1,.31,1.69-1,1.69-2s-.25-2.15.4-2.92c.21-.24.49-.41.72-.63a4.21,4.21,0,0,0,.94-2.73c.16-1.56,6.33,2.49,6.72,2.55,3,.5,4.78-2.44,6.81-4.05a18.16,18.16,0,0,1,3.54-2,82,82,0,0,0-58.85-55,26.52,26.52,0,0,0-3.78-.73c.38,1.89,1.55,4.87.28,6.66-1.61,2.28-5,.29-6.27,3,0,.68,1.1.57,1.62,1a2.42,2.42,0,0,1,.51,1c.15.35.49.7.85.59.42.63-.24,1.41-.8,1.92a5,5,0,0,0-1.52,2.16c-.52,1.79.66,3.56,1.41,5.26a25.14,25.14,0,0,1,1.32,4.41c0-.71,1-1,1.65-.67a7.58,7.58,0,0,1,1.54,1.46c.87.84,2,.33,2.94,1,1.18.89,1.93,2.48,3.37,2.72,1.76.3,3-1.57,3.81-3.17,1.93,1,3.12,3.49,5.3,3.65a5.61,5.61,0,0,0,2.43-.56l4.79-1.89a2.28,2.28,0,0,1,3.57,1.62l1,2.52a1.87,1.87,0,0,1,.2,1.08,1.63,1.63,0,0,1-.77.87,8.65,8.65,0,0,1-6.21,1.27,34.82,34.82,0,0,0,1.7,8.51c-1.63-.42-3.51.12-5-.5",
    style: {
      fill: "#D2232A",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.44,240a3.23,3.23,0,0,1-2.45,1.26,12.87,12.87,0,0,1-1.73-.33,1.6,1.6,0,0,0-1.58.53c-.41.62,0,1.45.37,2.09a2.47,2.47,0,0,0,1.26,1.25,11.73,11.73,0,0,0,1.33.07c.87.14,1.43,1,2,1.63s1.52,1.26,2.29.83c.5-.28.72-.92,1.21-1.23,1.2-.75,2.67.88,3.75.27,1.28-.73.81-2.82.28-4a10.77,10.77,0,0,0-2.55-3C268,236.87,268.38,237.71,266.44,240Z",
    style: {
      fill: "#D2232A",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,273.72c12.78-12.68,20.26-31.15,21.73-48.9,0-.5.08-1,.11-1.48-2.46-2.55-7.38-4.17-8.66.41-.51,0-.61-.34-1-.63-.61-.45-1.46.16-1.8.84-1.11,2.21-1.27,5-4.33,4.38-3.65-.71-1.17-2.27-2.36-4.28a4.09,4.09,0,0,0-.72-.72c-.87-.89-.75-2.31-.58-3.54a1.42,1.42,0,0,0,1.92-.8,2.32,2.32,0,0,1,.28-.84c.42-.49,1.27,0,1.47.58s0,1.28.18,1.9.81,1.24,1.36.91a1.12,1.12,0,0,0,.43-.66,3.49,3.49,0,0,0-.63-3.17,1.4,1.4,0,0,0-.06-2.72c-.89-.19-2.16.33-2.52-.51a2,2,0,0,1-.78,2c-2.36,1.71-7.66.19-7.14,5.21a18,18,0,0,1,.35,2.4,1.87,1.87,0,0,1-1.26,1.87c1.43,1.15.91,3.8,2.45,4.81a2,2,0,0,0,2.38-.26.86.86,0,0,1,.34-.26c.28-.09.54.18.83.24.49.1.93-.41,1.43-.44.71,0,1.1.81,1.23,1.51s.31,1.56,1,1.75c.23.06.48,0,.71.1a1.2,1.2,0,0,1,.78,1.13,3.58,3.58,0,0,1-.32,1.42c-.3.29-.82.11-1.11-.2a9.06,9.06,0,0,0-.78-1c-.19-.14-4.44.19-4.3-.12-.63,1.46-.95,4.66-3.15,3.85-.77-.29-1.57-.82-2.36-.58.38-1,.74-2.07,1.1-3.11-.33-.29-.82.1-1,.51s-.16.9-.5,1.16a1.36,1.36,0,0,1-.87.17l-2.94,0c-1.06,0-2.29,0-2.95.86s-.32,2.4.48,3.3a.79.79,0,0,1,0,1.39,4.4,4.4,0,0,0-1.45,3.72,2.88,2.88,0,0,0,2.87,2.46c.53-.05,1.19-.23,1.5.2.18.26.18.67.46.79s.66-.28.92-.58a1.59,1.59,0,0,1,1.94-.32c.31.19,1.3,3.21,1,3.65-.59,1-3.37.61-4.46.66a1.59,1.59,0,0,0-1.17.37c-.43.5-.08,1.29.4,1.74s1.12.79,1.36,1.4a4.25,4.25,0,0,1-.6,3.28c-.28.23-.63.35-.91.59a2.23,2.23,0,0,0-.45,2.3c.22.8.64,1.53.8,2.34.32,1.73-.63,3.61.06,5.23.33.78,1.36,1.4,2,.85s.55-1.6,1.28-1.68,1.57,1.68,2.15,2,1.38-.18,2.23.43C306.1,272.09,306.24,273.18,307,273.72Z",
    style: {
      fill: "#D2232A",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.42,165.41c.72-.92,1.18-2,2.53-2.21,1.84-.32,2.53.71,1.73,2.46a.71.71,0,0,0-.11.49c.12.53.92.22,1.37-.08a3.64,3.64,0,0,1,3.53-.17c.27.11.77-4.93.5-5.51-.92-2-5.17-1.07-4.3-3.28,1.6,0,3.23.17,4.82.29l.27-2.3c-.07.57,2.9.45,3.24.28,1.31-.67.95-3,3.3-2.66,3,.49,3.14,6.33-.24,5.37a15.23,15.23,0,0,0-1.2,5.66l-1.84,0a1.68,1.68,0,0,0-.22,1.49,4.58,4.58,0,0,0,5.07,0c1,.74,2.33,0,3.32-.67,1.39,2.24,5.38,1.93,6.4-.5s-1.52-5.51-4.1-5a5.9,5.9,0,0,0-1.25-3.39,7.67,7.67,0,0,0,7.34-5.09c.52-1.52.64-3.36,1.92-4.33.57-.43,1.29-.61,1.89-1,1.33-.9,1.72-2.65,1.93-4.25q.21-1.61.3-3.21a81.35,81.35,0,0,0-48.18,26.8,3.17,3.17,0,0,0,.12,1.65,3.51,3.51,0,0,0,2.55,1.58c3.9,1,6.39.81,9.09-2.23A2.75,2.75,0,0,0,198.42,165.41Z",
    style: {
      fill: "#D2232A",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.82,237.94c-.27,1.51-2.19,2.06-3.74,2.25l-7,.87c-1.1-2.89-4.52-2.91-6.92-1.79A81.31,81.31,0,0,0,241,299.13q4,.33,8,.27a1.37,1.37,0,0,0,.13-.2c1.22-2.13-.54-4-1.48-5.76-.21-.39-2.21-5.43-1.55-5.44a21.89,21.89,0,0,1-6.33-.82.66.66,0,0,1-.4-.24c-.2-.34.27-.66.64-.75,1-.22,1.95-.28,2.89-.56a3.33,3.33,0,0,0,2.24-1.76c.37-.92.09-2,.3-2.94a4,4,0,0,1,2.31-2.62,13,13,0,0,1,3.35-.9c-2.45-1.34-.66-4.12-2.59-6-.62-.59-1.52-1.32-1.14-2.1s1.66-.72,1.82-1.52c.11-.56-.48-1-1-1.15a6.3,6.3,0,0,1-1.67-.36,1.5,1.5,0,0,1-.47-2.09c.42-.59,1.2-.77,1.84-1.11s1.21-1.12.83-1.74a1.2,1.2,0,0,0-.37-.34c-1-.65-2.41-.11-3.42.57s-2,1.54-3.27,1.53a1,1,0,0,1,.4-1.38,1.91,1.91,0,0,0,.49-.26c.29-.29.08-.77-.12-1.13a7.33,7.33,0,0,1-.56-5.58l7.44.14c.06-.56.12-.89.72-1.06-1.67-2-3.48-3.84-5-6a1.46,1.46,0,0,0-.66-.64,4.54,4.54,0,0,0-1,0c-1.07-.15-1.24-1.62-1.13-2.69-.16-.33-.68-.19-.88.11s-.25.69-.49,1a1.35,1.35,0,0,1-1.5.16,3.56,3.56,0,0,1-1.89-4.63,1,1,0,0,1,.4-.52c.43-.24.94.06,1.42.14,1.9.34,1.61-1.75,1.16-2.75-.62-1.34-2.47-2.21-3.81-2.55-1.57-.41-12-2.41-10.32-5.82a1.59,1.59,0,0,1,.81-.68,24.11,24.11,0,0,1,3.2-.61c1-.29,2.06-1.38,1.6-2.37-.18-.4-.56-.67-.77-1.05-.59-1.07.32-2.45-.1-3.59a9.55,9.55,0,0,0-.92-1.39c-.28-.49-.33-1.22.15-1.51s1.27.16,1.84-.1a1,1,0,0,0,0-1.62,1.69,1.69,0,0,0-1.85.14,2.18,2.18,0,0,1-.89.49c-.61.08-1.07-.52-1.38-1.06l-1.49-2.53a1.43,1.43,0,0,0-1.18,1c-.19.52-.23,1.1-.44,1.62-1.06,2.51-4.87,2.21-4.38,5.64a1.64,1.64,0,0,1,1.66,2c-.4,1.22-2.22,1.88-2,3.13.09.44.44.79.51,1.23.19,1.21-1.68,1.66-2.49,1.93-2.67.92-2.85-.83-5.16-.94-1.06,0-2,.67-3.06.79s-1.93-.31-2.91-.25c-2.67.15-1.33,3.78-1.14,5.36-1.44-1-3.36.16-4.5,1.45-1.76,2-1.59,1.63-3.92,1.71a1.72,1.72,0,0,0-1.51.89c-.43,1,.49,2,.52,3.1,0,.52-.19,1-.15,1.53.13,1.35,1.72,1.93,2.68,2.87a3.68,3.68,0,0,1,1,3.24,7.85,7.85,0,0,1-2-.15l-1.21-2.33a4.92,4.92,0,0,0-1.36-1.85,4.44,4.44,0,0,1-1-.78c-.5-.7-.09-1.65,0-2.51.29-2.07-.75-5.55-1.26-7.6s-2-3.05-2.52-5.07a.64.64,0,0,0-.91-.29,1.38,1.38,0,0,0-.57.91,3.72,3.72,0,0,0,.22,2.5c-.47-1-3,1.66-3.2,2.17-.26.84.3,2,.27,2.89-.05,2.16-.57,3.36-2.79,1.78-.85-.6-1.94-1.32-2.84-.79a1.35,1.35,0,0,1-.75,1.52,2.87,2.87,0,0,1-1.81.14,1.78,1.78,0,0,1-1.09-.54,3,3,0,0,0-.4-.52c-.57-.45-1.29.32-1.6,1",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,174c.45.71,0,1.62-.54,2.28s-1.11,1.44-.89,2.24l2.9.27a.51.51,0,0,1,.57.71c-.07.62-.15,1.24-.22,1.86-.61.48-1.2-1-2-.87-.33.07-.5.43-.69.71-1.56,2.46-4.3.62-5.76-.66-1.7-1.48-4.16-1.57-6.41-1.6a3,3,0,0,0-2.28.6c-.56.56-.59,1.44-.87,2.19-.49,1.3-1.73,2.15-2.44,3.34-2.46,4.17,2,7.38,5.73,6.24,1.95-.58,1.61-.93,3.6-.35.83.24,1.85,0,2.36,1a1.55,1.55,0,0,1-1.35,2.26,6.56,6.56,0,0,1-3.21-.37c.38,1.32,0,2.82-.14,4.22a1.84,1.84,0,0,0-2,2.46c.63,0,1.49.25,1.44.88a1.22,1.22,0,0,1-.22.51,20.91,20.91,0,0,0-1.39,1.86c-.59,1-.58,4.15-2.07,4.52-.26.07-.54,0-.8.13a1.19,1.19,0,0,0-.73,1.39,1.64,1.64,0,0,0,1.18,1.14c.37.1.77.09,1.13.21,1.92.67.23,2.57.69,3.51a17.32,17.32,0,0,0,3.84,2.55,4.55,4.55,0,0,0-2.17,3.42c0,1.56,1.15,2.32,2.63,2.79s3.48.65,4.61,1.09c.61.23,1.35.45,1.86.05s.5-1.7,1.24-2.05a2.16,2.16,0,0,1,.76-.12,2.87,2.87,0,0,0,2.45-3.23c.35-.45,1-.41,1.61-.39s1.3-.18,1.38-.75-.74-1-1.4-1a7.16,7.16,0,0,0-2,.16,2.33,2.33,0,0,1-1.47.06,2,2,0,0,1-.78-.81,4.42,4.42,0,0,1-.82-2.58,1.89,1.89,0,0,1,1.73-1.79,3.64,3.64,0,0,0,.73.05c.63-.1.9-.87.86-1.5a5.69,5.69,0,0,1-.08-1.88c.17-.61,1-1.06,1.44-.59.35-.8.58-2-.21-2.37a2.3,2.3,0,0,0-.83-.14c-1.74-.17-4.09-2.52-2.15-3.86,1.27-.88,3.32,1,4.43-.71.54-.8.21-2,.76-2.75.32-.23.7.24.77.64a3.72,3.72,0,0,1-1.21,3.42c1,.57,2.52-.08,3.19.83s-.32,2.48.55,3.18a1.73,1.73,0,0,0,.89.31c1.57.23,4.49,0,4.58,2.2a3.64,3.64,0,0,0,.05.81c.24.79,1.32.87,2.14.78.42-.8-.13-1.74-.5-2.58s-.33-2.11.55-2.32c.64-.15,1.38.4,1.91,0,.25-.17.36-.5.63-.64.65-.34,1.19.65,1.89.87,1,.31,1.69-1,1.69-2s-.25-2.15.4-2.92c.21-.24.49-.41.72-.63a4.21,4.21,0,0,0,.94-2.73c.16-1.56,6.33,2.49,6.72,2.55,3,.5,4.78-2.44,6.81-4.05a18.16,18.16,0,0,1,3.54-2,82,82,0,0,0-58.85-55,26.52,26.52,0,0,0-3.78-.73c.38,1.89,1.55,4.87.28,6.66-1.61,2.28-5,.29-6.27,3,0,.68,1.1.57,1.62,1a2.42,2.42,0,0,1,.51,1c.15.35.49.7.85.59.42.63-.24,1.41-.8,1.92a5,5,0,0,0-1.52,2.16c-.52,1.79.66,3.56,1.41,5.26a25.14,25.14,0,0,1,1.32,4.41c0-.71,1-1,1.65-.67a7.58,7.58,0,0,1,1.54,1.46c.87.84,2,.33,2.94,1,1.18.89,1.93,2.48,3.37,2.72,1.76.3,3-1.57,3.81-3.17,1.93,1,3.12,3.49,5.3,3.65a5.61,5.61,0,0,0,2.43-.56l4.79-1.89a2.28,2.28,0,0,1,3.57,1.62l1,2.52a1.87,1.87,0,0,1,.2,1.08,1.63,1.63,0,0,1-.77.87,8.65,8.65,0,0,1-6.21,1.27,34.82,34.82,0,0,0,1.7,8.51c-1.63-.42-3.51.12-5-.5",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.44,240a3.23,3.23,0,0,1-2.45,1.26,12.87,12.87,0,0,1-1.73-.33,1.6,1.6,0,0,0-1.58.53c-.41.62,0,1.45.37,2.09a2.47,2.47,0,0,0,1.26,1.25,11.73,11.73,0,0,0,1.33.07c.87.14,1.43,1,2,1.63s1.52,1.26,2.29.83c.5-.28.72-.92,1.21-1.23,1.2-.75,2.67.88,3.75.27,1.28-.73.81-2.82.28-4a10.77,10.77,0,0,0-2.55-3C268,236.87,268.38,237.71,266.44,240Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,273.72c12.78-12.68,20.26-31.15,21.73-48.9,0-.5.08-1,.11-1.48-2.46-2.55-7.38-4.17-8.66.41-.51,0-.61-.34-1-.63-.61-.45-1.46.16-1.8.84-1.11,2.21-1.27,5-4.33,4.38-3.65-.71-1.17-2.27-2.36-4.28a4.09,4.09,0,0,0-.72-.72c-.87-.89-.75-2.31-.58-3.54a1.42,1.42,0,0,0,1.92-.8,2.32,2.32,0,0,1,.28-.84c.42-.49,1.27,0,1.47.58s0,1.28.18,1.9.81,1.24,1.36.91a1.12,1.12,0,0,0,.43-.66,3.49,3.49,0,0,0-.63-3.17,1.4,1.4,0,0,0-.06-2.72c-.89-.19-2.16.33-2.52-.51a2,2,0,0,1-.78,2c-2.36,1.71-7.66.19-7.14,5.21a18,18,0,0,1,.35,2.4,1.87,1.87,0,0,1-1.26,1.87c1.43,1.15.91,3.8,2.45,4.81a2,2,0,0,0,2.38-.26.86.86,0,0,1,.34-.26c.28-.09.54.18.83.24.49.1.93-.41,1.43-.44.71,0,1.1.81,1.23,1.51s.31,1.56,1,1.75c.23.06.48,0,.71.1a1.2,1.2,0,0,1,.78,1.13,3.58,3.58,0,0,1-.32,1.42c-.3.29-.82.11-1.11-.2a9.06,9.06,0,0,0-.78-1c-.19-.14-4.44.19-4.3-.12-.63,1.46-.95,4.66-3.15,3.85-.77-.29-1.57-.82-2.36-.58.38-1,.74-2.07,1.1-3.11-.33-.29-.82.1-1,.51s-.16.9-.5,1.16a1.36,1.36,0,0,1-.87.17l-2.94,0c-1.06,0-2.29,0-2.95.86s-.32,2.4.48,3.3a.79.79,0,0,1,0,1.39,4.4,4.4,0,0,0-1.45,3.72,2.88,2.88,0,0,0,2.87,2.46c.53-.05,1.19-.23,1.5.2.18.26.18.67.46.79s.66-.28.92-.58a1.59,1.59,0,0,1,1.94-.32c.31.19,1.3,3.21,1,3.65-.59,1-3.37.61-4.46.66a1.59,1.59,0,0,0-1.17.37c-.43.5-.08,1.29.4,1.74s1.12.79,1.36,1.4a4.25,4.25,0,0,1-.6,3.28c-.28.23-.63.35-.91.59a2.23,2.23,0,0,0-.45,2.3c.22.8.64,1.53.8,2.34.32,1.73-.63,3.61.06,5.23.33.78,1.36,1.4,2,.85s.55-1.6,1.28-1.68,1.57,1.68,2.15,2,1.38-.18,2.23.43C306.1,272.09,306.24,273.18,307,273.72Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.42,165.41c.72-.92,1.18-2,2.53-2.21,1.84-.32,2.53.71,1.73,2.46a.71.71,0,0,0-.11.49c.12.53.92.22,1.37-.08a3.64,3.64,0,0,1,3.53-.17c.27.11.77-4.93.5-5.51-.92-2-5.17-1.07-4.3-3.28,1.6,0,3.23.17,4.82.29l.27-2.3c-.07.57,2.9.45,3.24.28,1.31-.67.95-3,3.3-2.66,3,.49,3.14,6.33-.24,5.37a15.23,15.23,0,0,0-1.2,5.66l-1.84,0a1.68,1.68,0,0,0-.22,1.49,4.58,4.58,0,0,0,5.07,0c1,.74,2.33,0,3.32-.67,1.39,2.24,5.38,1.93,6.4-.5s-1.52-5.51-4.1-5a5.9,5.9,0,0,0-1.25-3.39,7.67,7.67,0,0,0,7.34-5.09c.52-1.52.64-3.36,1.92-4.33.57-.43,1.29-.61,1.89-1,1.33-.9,1.72-2.65,1.93-4.25q.21-1.61.3-3.21a81.35,81.35,0,0,0-48.18,26.8,3.17,3.17,0,0,0,.12,1.65,3.51,3.51,0,0,0,2.55,1.58c3.9,1,6.39.81,9.09-2.23A2.75,2.75,0,0,0,198.42,165.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Connections--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.23,133.29a11.92,11.92,0,1,0,11.91-11.91A11.9,11.9,0,0,0,50.23,133.29Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.14,
    cy: 133.29,
    r: 11.23,
    transform: "translate(-20.55 11.68) rotate(-9.22)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.47,133.1a1.8,1.8,0,0,0,1.38,1.66,2.55,2.55,0,0,0,0,1.67c.33.91,2.17.91,2.17.91a.93.93,0,0,0,.83.56c0,.06.09.1.12.15l.26.36c.23,1.81.19,3.71-.7,4.68a0,0,0,0,1,0,0c-.77.08-1.54.19-2.31.31-.37.05-.73.12-1.09.19a11.9,11.9,0,0,0,13.28-.94H68.34c-.62,0-1.33,0-2.09,0l0-.05a2.4,2.4,0,0,1-2.16-1.58,3.55,3.55,0,0,1-.15-1.23,4.43,4.43,0,0,0,1-.33,4.05,4.05,0,0,0,2-2.22,2.83,2.83,0,0,0,.14-.41,10.43,10.43,0,0,0,.26-3.55,1.68,1.68,0,0,0,.81-1.14,1.23,1.23,0,0,0-.84-1.5A1.59,1.59,0,0,0,68.52,129a1.27,1.27,0,0,0-1.22-1.48s.43-.62-.41-1.79a1.5,1.5,0,0,0-2-.45,2.35,2.35,0,0,0-2.34-1,2.52,2.52,0,0,0-1.82,1.2s0-.86-1.65-.38a2.23,2.23,0,0,0-1.45,2.37,1.21,1.21,0,0,0-1.68.63c-.57,1.19.67,3.27.67,3.27A1.63,1.63,0,0,0,55.47,133.1Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.23,133.29a11.92,11.92,0,1,0,11.91-11.91A11.9,11.9,0,0,0,50.23,133.29Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.11,
    cy: 342.48,
    r: 10.59,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1,342.48a10,10,0,1,1-10-10A9.92,9.92,0,0,1,66.1,342.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,348.6a10,10,0,0,1-13.51,2.13c.33-.76.54-1.22.54-1.22a29.65,29.65,0,0,1,3.8-.93,3,3,0,0,1,1.31-.65,3.84,3.84,0,0,0-.07-2.27,3.92,3.92,0,0,1-1-1,2.46,2.46,0,0,1-.54-.53c-.31-.13-2.43-1.12-2.54-4.6a3,3,0,0,1,0-.42c-.66-.07-1.35.14-.87,1.48.82,2.31,0,3.52,0,3.52a8.68,8.68,0,0,0-.08-1.53c0,2.39-1.29,2.54-1.29,2.54s.82-.86-.39-3.51-.86-6.26,1.45-6.41a3,3,0,0,1,2.55,1.07,3.85,3.85,0,0,1,4.52-.53s2.07-.5,2.66,0c.12.12,0,.39-.22.75a2.74,2.74,0,0,1,1.16,1.71,4.15,4.15,0,0,1-.57,3.25c.28,2.62-.17,4.59-2.26,4.77,0,.07,0,.13,0,.2s0,.18,0,.26a2.92,2.92,0,0,0,.15,1.12,5.84,5.84,0,0,1,.87.24c1.87,0,4,.2,4,.2h0A2.93,2.93,0,0,1,64,348.6Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.11,
    cy: 342.48,
    r: 10.59,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.89,
    cy: 259.76,
    r: 11.69,
    transform: "translate(-53.67 389.96) rotate(-45)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.91,259.76a11,11,0,1,1-11-11A11,11,0,0,1,454.91,259.76Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.06,265.87a11,11,0,0,1-15.92,2.6,6.59,6.59,0,0,1,.06-1.81c.14-1.34,1.69-2.43,1.67-3.37s-1.6-2.16-.59-2.71,1.23-2.64.42-3.81a2.57,2.57,0,0,1,.06-3.58,4.68,4.68,0,0,1,3-1.64,5.61,5.61,0,0,1,3.26-.47,7,7,0,0,1,3.24,1.1,4.8,4.8,0,0,1,1.69,2.08,6.55,6.55,0,0,1,.34,4.77c-.55,1.58,1.9,1.49,2,2.93s-1.15,1.53-.93,2.5C451.43,264.9,452.28,265.32,453.06,265.87Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.89,
    cy: 259.76,
    r: 11.69,
    transform: "translate(-53.67 389.96) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.29,
    y: 162.47,
    width: 97.22,
    height: 1,
    transform: "translate(-36.04 152.22) rotate(-23.44)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.61,
    y: 86.85,
    width: 1,
    height: 72.46,
    transform: "translate(-34.82 123.75) rotate(-31.76)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.46,
    y: 266.39,
    width: 101.09,
    height: 1,
    transform: "translate(-51.67 35.2) rotate(-11.83)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.29,
    y: 162.47,
    width: 97.22,
    height: 1,
    transform: "translate(-36.04 152.22) rotate(-23.44)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.69,
    y: 232.29,
    width: 1,
    height: 107.23,
    transform: "translate(-99.27 226.36) rotate(-32.07)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.69,
    y: 232.29,
    width: 1,
    height: 107.23,
    transform: "translate(-99.27 226.36) rotate(-32.07)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.61,
    y: 86.85,
    width: 1,
    height: 72.46,
    transform: "translate(-34.82 123.75) rotate(-31.76)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.46,
    y: 266.39,
    width: 101.09,
    height: 1,
    transform: "translate(-51.67 35.2) rotate(-11.83)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.88,368.49,94,277.42l13.7-103.58.11-.12,73-81.92.19,0,132.27-18.3,80.77,70,0,.26L373.12,331.75l-.36.07ZM95.06,277.05l96.13,90.36,181-36.5L393,143.84l-80-69.3L181.3,92.74l-72.65,81.53Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.88,368.49,94,277.42l13.7-103.58.11-.12,73-81.92.19,0,132.27-18.3,80.77,70,0,.26L373.12,331.75l-.36.07ZM95.06,277.05l96.13,90.36,181-36.5L393,143.84l-80-69.3L181.3,92.74l-72.65,81.53Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.68 153.88 219.18 162.64 217.68 153.88 220.68 153.88",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.52,153.88a4.34,4.34,0,1,1-4.34-4.34A4.34,4.34,0,0,1,223.52,153.88Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.61,150.82c.48.63.1,1.74-.86,2.46s-2.11.8-2.6.17-.1-1.74.85-2.46S219.12,150.19,219.61,150.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.8 182.31 304.3 191.07 302.8 182.31 305.8 182.31",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.3,
    cy: 182.31,
    r: 4.34,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.72,179.25c.49.63.1,1.74-.85,2.46s-2.12.8-2.6.17-.1-1.74.85-2.46S304.24,178.61,304.72,179.25Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.98 256.02 193.48 264.78 191.98 256.02 194.98 256.02",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.48,
    cy: 256.02,
    r: 4.34,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.91,253c.48.63.1,1.74-.85,2.46s-2.12.81-2.61.17-.1-1.74.86-2.46S193.42,252.33,193.91,253Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.23 240.47 315.73 249.22 314.23 240.47 317.23 240.47",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.07,240.47a4.34,4.34,0,1,1-4.34-4.35A4.34,4.34,0,0,1,320.07,240.47Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.15,237.4c.49.64.11,1.74-.85,2.47s-2.12.8-2.6.17-.1-1.74.85-2.47S315.67,236.77,316.15,237.4Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.1,
    cy: 76.01,
    r: 18.2,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.25,76A17.16,17.16,0,1,1,312.1,58.85,17.1,17.1,0,0,1,329.25,76Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.67,87.68a17.15,17.15,0,0,1-25.8-.74l.28-.09A3.68,3.68,0,0,1,300,86a.71.71,0,0,1,0-.14l.3,0a3.53,3.53,0,0,1,1.88-.49,3.44,3.44,0,0,1,.55,0l1.07-.2s0,.11,0,.3l5.78.39a3,3,0,0,0,1.06-1.5,5.19,5.19,0,0,0,.21-2,6.11,6.11,0,0,1-2.4-.63,6.21,6.21,0,0,1-3-3.38,6.13,6.13,0,0,1-.18-.61,15.45,15.45,0,0,1-.09-6.48v0H305a.18.18,0,0,1-.15-.19s0,0,0,0a.2.2,0,0,1,.23-.17h.05a13,13,0,0,1,.29-3.87,4.6,4.6,0,0,1,0-3.92c.64-.92.14-.42,1.82-.57s.67-1.63,1.74-1.65.85.66,2.16,1.16.83-1,2.33-1.14,1.7,1,2.77,1.28a5.1,5.1,0,0,0,2.07,0c.78,0,.85,2.28,1.18,2.7s.89-.21,1.6,1a1.08,1.08,0,0,1,.12.56c0,1.51-1.88,4.38-1.88,4.38-.09.66-.21,1.37-.39,2.13a1.94,1.94,0,0,1,.34,2.26,4.17,4.17,0,0,1-1.66,1.77,12.27,12.27,0,0,1-1.08,1.89c-.47,2.62-.7,5.71.19,7.66A58.15,58.15,0,0,1,324.67,87.68Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.1,
    cy: 76.01,
    r: 18.2,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.03,
    cy: 366.36,
    r: 18.2,
    transform: "translate(-203.11 242.38) rotate(-45)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.19,366.36A17.16,17.16,0,1,1,191,349.21,17.07,17.07,0,0,1,208.19,366.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,378.82a17.15,17.15,0,0,1-21.5,1.69c1.25-.18,2.56-.33,3.89-.47,1-2.25.77-5.82.22-8.85A14.58,14.58,0,0,1,184.2,369a4.73,4.73,0,0,1-1.92-2,2.27,2.27,0,0,1,.38-2.62,20,20,0,0,1-.55-4.13l-.08,0s-1.38-5.33,3.78-7.28,10.37,1.54,10.37,1.54,1.12-2.08,2.45-1.54c1.14.46.53,1.94.32,2.39a2.78,2.78,0,0,1,1.17-1c.91-.41,2.17.75-.66,3.58a3.7,3.7,0,0,1-1,.72,13.75,13.75,0,0,1,.08,3.87,17.79,17.79,0,0,1-.11,7.47,5.48,5.48,0,0,1-.22.72,7,7,0,0,1-3.42,3.89,6.57,6.57,0,0,1-2.77.74,6.56,6.56,0,0,0,.23,2.28,3.56,3.56,0,0,0,1.23,1.73c2.73-.18,5.11-.32,6.68-.45a3.18,3.18,0,0,0,0-.34l1.24.23A5,5,0,0,1,202.82,378.82Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.03,
    cy: 366.36,
    r: 18.2,
    transform: "translate(-203.11 242.38) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.18,
    cy: 174.05,
    r: 18.2,
    transform: "translate(-86.07 239.35) rotate(-76.72)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.34,174.05a17.16,17.16,0,1,1-17.16-17.15A17.1,17.1,0,0,1,125.34,174.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,185.48a17.17,17.17,0,0,1-22.9,2.45l6.8-2.1c.13.14.25.3.38.47l.87-.17c.55-.1,1.09-.17,1.64-.26a5.09,5.09,0,0,0,.68-2.1l-.94,0c.19-.68-.82-2.09-.82-2.09l-.34,1.86a3.6,3.6,0,0,1-1.14-.4c-.46-.29-1-2.32-1-2.32s-1.18,2-1.44,2.43-.94,0-.94,0a6.92,6.92,0,0,1,.11-3.47,1.18,1.18,0,0,0-1.2-1.72,6.15,6.15,0,0,1-.45,1.94,6,6,0,0,0-.46,2.54c0,.72.06,1.23-.45,1.23s-.58-.46-.52-1.23-.74-1.51-.28-2.14.11-2.34.11-2.34c-.28,1.2-1.6,1.14-1.82,2s.62,2.06.22,2.49-1.08,0-1.08,0,.57-.94.17-1.49-1-.82-.75-1.94.8-1.11.64-2.34-.75-1.17,0-1.63a6.08,6.08,0,0,0,1.71-3.56c0-1-.4-3.11,1.2-3.87s2-1.35,1.71-3.37,1.25-1.87,3.2-1.47c0,0,1-1.54,1.88-1.25s1.6.11,1.79-.4,2.72-.46,3.1,0a2.73,2.73,0,0,0,2.55.45c.83-.34,3,1,3,1.94s-.06,1.43,1.12,1.95,1.4.8,1.91,2.84-.34,2.87.69,3.66.91,3.94,1,4.92,0,2,0,2l-.29.08c-.28.08-.51-1.05-.46-1.89s-1.73-2-1.88-2.07c0,.08.36.78.57,1.33a9.87,9.87,0,0,1,.23,3.06c-.06,1,1.08,1.51,1.08,1.51l-1.25.63s-1-2.08-.64-3.16a2.29,2.29,0,0,0-.62-2v2s-.34.74-.85,1.71.4,1.26.54,1.77-1.12.54-1.12.54l-.24-1.23-.43,1.23a6.48,6.48,0,0,1-2.47.76,4.18,4.18,0,0,0,.5,1.95l1.22-.06c.8,0,1.64,0,2.45,0h0C118.6,185.32,120,185.41,121,185.48Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.18,
    cy: 174.05,
    r: 18.2,
    transform: "translate(-86.07 239.35) rotate(-76.72)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.08,145.72a33.24,33.24,0,0,1-6.65,20,34.11,34.11,0,0,1-10.58,9.2A33.3,33.3,0,0,1,380,176.06c-.39-.16-.78-.35-1.16-.55v0a32,32,0,0,1-6.54-4.29,33.34,33.34,0,1,1,54.83-25.48Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.74,
    cy: 145.72,
    r: 32.37,
    transform: "translate(12.29 321.1) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.25,160.84l3.13-13s2-1.58,2.1-2.73-1.22-7.94-2.08-8.35-5.94,1.36-6.18,2.81,1.75,7.16,2.15,7.62l-5.13,15.1Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.76,153.41l-1.88,17a32.16,32.16,0,0,1-7.24-8.67c1.16-4.09,2.33-7.76,2.88-9.41.18-.59.29-.92.29-.92l1.08.14,4.45.56.55.07Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.26,164.39l-2.9,10.79c-.38-.16-.76-.35-1.12-.54h0a31.2,31.2,0,0,1-6.34-4.18c.23-.52,6.17-13.93,8.39-13.77Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.76,153.41l-1.88,17a32.16,32.16,0,0,1-7.24-8.67c1.16-4.09,2.33-7.76,2.88-9.41.18-.59.29-.92.29-.92l1.08.14,4.45.56.55.07Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.26,164.39l-2.9,10.79c-.38-.16-.76-.35-1.12-.54h0a31.2,31.2,0,0,1-6.34-4.18c.23-.52,6.17-13.93,8.39-13.77Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.15 151.16 375.13 153.46 368.03 152.28 368.19 150.97 376.15 151.16",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.44,134.58c-.83,3.18,3.7,11.93,1.86,27.85s-19.29,14.94-27.14,9.64-6.49-34.11-3.79-39.79S413.44,134.58,413.44,134.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,160.32c-.17.47-.31.92-.47,1.38s-.32.91-.47,1.35c-.29.87-.57,1.73-.85,2.56-.56,1.66-1.06,3.24-1.54,4.73a30.48,30.48,0,0,1-5.34,3.71,32.34,32.34,0,0,1-29,1.13c-.38-.16-.76-.35-1.12-.54,0-.32,0-.65,0-.95s0-.63,0-.93c0-.92.05-1.77.07-2.58,0-.53.05-1.06.06-1.54,0-.26,0-.49,0-.74.05-.89.09-1.69.15-2.45,0-.24,0-.49.05-.72,0-.71.11-1.34.15-1.93.37-3.7.86-5.16,1.18-5.75a1.18,1.18,0,0,1,.17-.25c.09-.11.14-.12.14-.12l1.31-.11c2.16-.19,6.64-.5,10.69-.48h.23c.54,0,1.07,0,1.61.08,2.09.11,4.18.29,6.24.54l2.3.32c.83.12,1.66.26,2.49.4l.35.07a80.92,80.92,0,0,1,9.07,2.07c.83.23,1.66.48,2.48.74Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,160.32s0,0,0,0c-.16.45-.32.9-.45,1.35s-.32.91-.47,1.35c-.29.87-.57,1.73-.85,2.56-.56,1.66-1.06,3.24-1.54,4.73a30.48,30.48,0,0,1-5.34,3.71,32.34,32.34,0,0,1-29,1.13c-.38-.16-.76-.35-1.12-.54h0c0-.32,0-.64,0-.94s0-.63,0-.93c0-.92.05-1.77.07-2.58,0-.53.05-1.06.06-1.54,0-.26,0-.49,0-.74,0-.89.09-1.69.15-2.45,0-.24,0-.49.05-.72,0-.71.11-1.34.15-1.93.37-3.7.86-5.16,1.18-5.75a1.18,1.18,0,0,1,.17-.25c.09-.11.14-.12.14-.12l1.31-.11c2.16-.19,6.64-.5,10.69-.48h.23c.54,0,1.07,0,1.61.08,2.09.11,4.18.29,6.24.54l2.3.32c.83.12,1.66.26,2.49.4l.35.07a80.92,80.92,0,0,1,9.07,2.07C416.39,159.81,417.22,160.06,418,160.32Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.32,155.23c7.14.56,8,2.72,7.26,3.85S396.14,169.66,393.23,176C393.23,176,382.74,153.93,399.32,155.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.63,162.43c7.07-.91,9.2-3.93,9.2-3.93-4.49-4.23-.76-11.56-.76-11.56l-8.51,1.58a25.08,25.08,0,0,1,.33,3.59c.07,5.16-2.27,5.21-2.27,5.21C392.13,160.12,395.63,162.43,395.63,162.43Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.56,148.52a25.08,25.08,0,0,1,.33,3.59c5.75,0,8.18-5.17,8.18-5.17Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.26,124.73c-7.39-.4-10,3.43-10.95,11-1.2,9.49.54,16.37,9.9,14.84C411.92,148.52,412.55,125.41,400.26,124.73Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.11,135.6a15.84,15.84,0,0,1-2.32,3,2,2,0,0,0,1.91.94Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.67,135.24c0,.61.25,1.13.65,1.16s.77-.44.82-1-.24-1.13-.65-1.16S398.72,134.63,398.67,135.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.66,134.24l-1.28-.62S399,134.78,399.66,134.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.14,134.52c-.05.61.24,1.13.65,1.16s.77-.43.82-1-.25-1.12-.65-1.16S391.19,133.92,391.14,134.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.13,133.53l-1.28-.62S391.42,134.07,392.13,133.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.18,131.78a.32.32,0,0,1-.28-.15,3.56,3.56,0,0,0-2.85-1.15.34.34,0,0,1-.36-.32.32.32,0,0,1,.31-.36,4.13,4.13,0,0,1,3.45,1.43.35.35,0,0,1-.07.48A.37.37,0,0,1,402.18,131.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.69,130.32a.34.34,0,0,1-.18-.64,3.76,3.76,0,0,1,3.3-.46.33.33,0,0,1,.17.45.34.34,0,0,1-.44.18,3.13,3.13,0,0,0-2.68.42A.26.26,0,0,1,390.69,130.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.62,142.46a18.6,18.6,0,0,1,.72,2.62l.48,0c2.16-.1,3.13-.86,3.55-1.68a2.79,2.79,0,0,0,.29-1.29,2.68,2.68,0,0,0-.1-.75,10.27,10.27,0,0,1-4.21,1.08C394.9,142.46,394.62,142.46,394.62,142.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.35,142.42l.24.76c2-.1,3.46-.44,4.07-1.09a2.68,2.68,0,0,0-.1-.75A10.27,10.27,0,0,1,395.35,142.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.82,145.06c2.16-.1,3.13-.86,3.55-1.68A7.16,7.16,0,0,0,397,144,2.6,2.6,0,0,0,395.82,145.06Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.66,137.64s-3.12-6.26-2.34-10.93c0,0-14.33-6.79-15.87,8,0,0-.71-13.29,12-12.89s11.66,19,4.79,24.19C406.26,146.06,409.6,141.56,407.66,137.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.37,139.14a3.26,3.26,0,0,1,3.66-2.78c2.27.38,3.11,5.14-2.65,6C406.55,142.44,406.13,141.62,406.37,139.14Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.35,126a28,28,0,0,0,4.31,17.41c4.16,6.29-.62,11.79-.62,11.79s7.39-4.7,7.65-11.79c0,0,6.1-16.95-6.57-21.52,0,0-.05-3.81-8.31-3.09s-14.91,7.81-16.17,16.83,3.44,19.08,3.44,19.08S382.08,122.71,403.35,126Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.83,126.13a21,21,0,0,0-.62,6.55,32.4,32.4,0,0,0,1.06,6.62,27.8,27.8,0,0,0,2.48,6.25,18.23,18.23,0,0,0,4.18,5.26,18.26,18.26,0,0,1-4.4-5.14,28.16,28.16,0,0,1-2.74-6.23,33.93,33.93,0,0,1-1.33-6.71,22.12,22.12,0,0,1,.41-6.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.65,165.12a30.89,30.89,0,0,1-4.93,5.22,30.48,30.48,0,0,1-5.34,3.71c.11-.42.25-.85.4-1.28a33,33,0,0,1,5.33-9.14,35,35,0,0,1,2.92-3.28l0,0C418.82,161,419.32,162.7,419.65,165.12Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.65,165.12a30.89,30.89,0,0,1-4.93,5.22,30.48,30.48,0,0,1-5.34,3.71c.11-.42.25-.85.4-1.28a33,33,0,0,1,5.33-9.14,35,35,0,0,1,2.92-3.28l0,0C418.82,161,419.32,162.7,419.65,165.12Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 373.86,
    cy: 328.24,
    r: 35.76,
    transform: "translate(-122.6 360.5) rotate(-45)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.62,328.24a34.4,34.4,0,0,1-3.71,15.6c-.47.94-1,1.85-1.54,2.74-.43.69-.88,1.37-1.37,2a34.56,34.56,0,0,1-7.25,7.39c-.63.49-1.28.93-1.95,1.38a35.08,35.08,0,0,1-8.71,4.09,34.9,34.9,0,0,1-24.6-1.57c-.56-.26-1.12-.54-1.67-.82h0a35.12,35.12,0,0,1-14.55-14.32c-.46-.85-.89-1.75-1.28-2.65h0a34.76,34.76,0,1,1,66.64-13.87Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.51,326.86a17.73,17.73,0,0,1-2.15,2.61l-3,14.19-2,9.26a35.26,35.26,0,0,1-6.13-8.16c.24-.75.5-1.52.75-2.32,2.12-6.58,4.56-14.19,4.74-14.94.32-1.34-.85-7.92-.58-9.12s6.27-2.63,7.57-2.61S357,326,356.51,326.86Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2,342.5v.05l-1.26,12.93-.44,4.42c-.56-.26-1.12-.54-1.67-.82h0a35.12,35.12,0,0,1-14.55-14.32c-.46-.85-.89-1.75-1.28-2.65l2,.33,7.34,1.22,1.58.26-1.85,9S357.82,343.51,361.2,342.5Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2,342.5v.05l-1.26,12.93-.44,4.42c-.56-.26-1.12-.54-1.67-.82h0a35.12,35.12,0,0,1-14.55-14.32c-.46-.85-.89-1.75-1.28-2.65l2,.33,7.34,1.22,1.58.26-1.85,9S357.82,343.51,361.2,342.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.91,343.84c-.47.94-1,1.85-1.54,2.74-.43.69-.88,1.37-1.37,2a34.56,34.56,0,0,1-7.25,7.39c-.63.49-1.28.93-1.95,1.38a35.08,35.08,0,0,1-8.71,4.09,34.9,34.9,0,0,1-24.6-1.57c-.56-.26-1.12-.54-1.67-.82h0a113.5,113.5,0,0,1,3.37-16.53v-.05a73.48,73.48,0,0,1,11-2.25h.18a137,137,0,0,1,16.09-.34h0A75.05,75.05,0,0,1,399.61,341,31.19,31.19,0,0,1,404.91,343.84Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.91,343.84c-.47.94-1,1.85-1.54,2.74-.43.69-.88,1.37-1.37,2a34.56,34.56,0,0,1-7.25,7.39c-.63.49-1.28.93-1.95,1.38a35.08,35.08,0,0,1-8.71,4.09,34.9,34.9,0,0,1-24.6-1.57c-.56-.26-1.12-.54-1.67-.82h0a113.5,113.5,0,0,1,3.37-16.53v-.05a73.48,73.48,0,0,1,11-2.25h.18a137,137,0,0,1,16.09-.34h0A75.05,75.05,0,0,1,399.61,341,31.19,31.19,0,0,1,404.91,343.84Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.75,356c-.63.49-1.28.93-1.95,1.38a35.08,35.08,0,0,1-8.71,4.09,34.9,34.9,0,0,1-24.6-1.57c-.56-.26-1.12-.54-1.67-.82h0c.05-.3.09-.58.13-.86a32.29,32.29,0,0,1,2-2.74,93.31,93.31,0,0,1,11.17-11.41,6.41,6.41,0,0,0,3.89,2c3.28.65,7-.89,10.14-2.74a78,78,0,0,1,5.45,6,31.42,31.42,0,0,1,3.69,5.55C394.45,355.27,394.61,355.65,394.75,356Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.52,340a16.82,16.82,0,0,1-11.84,5.37c-6.73.3-4.48-5-4.48-5,2.47-.65,3.84-1.8,4.53-3.21.87-1.82.62-4.06.06-6.26l-.12-.46,9.84-8.76C385.6,326.88,384.78,336.52,388.52,340Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.89,329.34c-.52,3.38-4.63,6.7-8.16,7.75.87-1.82.62-4.06.06-6.26l8.15-6.24A12.65,12.65,0,0,1,384.89,329.34Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.52,310.24c2.33,2.63.22,5.55-7.47,9-1.73-4-.49-10.67,2-11.78S376.48,308,378.52,310.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.32,318.59c-2.07,6.83-2.94,10.92-7.27,13.65-6.52,4.09-14.32-1.1-14.33-8.41,0-6.56,3.37-16.62,10.8-17.76a9.73,9.73,0,0,1,11.13,8.07A9.85,9.85,0,0,1,389.32,318.59Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.53,318c-.13.56-.54.95-.91.86s-.55-.61-.42-1.17.53-1,.9-.87S378.62,317.48,378.53,318Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.12,316.53c-.13.56-.54,1-.91.86s-.56-.61-.43-1.18.55-.95.91-.86S372.26,316,372.12,316.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.15,317.29a20.33,20.33,0,0,1-3.84,4.18,3.36,3.36,0,0,0,2.58,1.14Z",
    style: {
      fill: "#892b29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.76,316.44a.41.41,0,0,0,.22,0,.35.35,0,0,0,.18-.45,3.37,3.37,0,0,0-2.37-2,.33.33,0,0,0-.39.25v0a.35.35,0,0,0,.28.39h0a2.66,2.66,0,0,1,1.85,1.6A.38.38,0,0,0,380.76,316.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.72,313.68a.36.36,0,0,0,.35-.12,2.71,2.71,0,0,1,2.21-1.05.35.35,0,0,0,.38-.31.34.34,0,0,0-.3-.37,3.38,3.38,0,0,0-2.82,1.31.33.33,0,0,0,0,.47h0A.33.33,0,0,0,369.72,313.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,311.81c-3.5.34-3.93,3.92-.63,11.67,4-1.78,7.62-7.5,6.55-10S391.07,311.51,388,311.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.3,324.91a6.72,6.72,0,0,1-4.07,3.2c-2.29.62-3.42-1.43-2.77-3.58.59-1.94,2.49-4.6,4.78-4.27A3,3,0,0,1,391.3,324.91Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.29,308.92s-.73,7.18,5.81,9.31,9-1.61,9-1.61a13.21,13.21,0,0,1-1.67-.28,7.14,7.14,0,0,0,1.68-6.6c-1.11-3.74-6.89-8.81-12.25-8.33a12.12,12.12,0,0,0-9.55-1.47c-5.29,1.5-6,7.55-6,7.55s.69-3.6,3.1-4c0,0-4.53,6.62-1,9.58C370.44,313,372.67,306,381.29,308.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.66,325.21a19,19,0,0,1,1.33,2.44l.47-.13c2.14-.6,2.93-1.59,3.16-2.5a2.9,2.9,0,0,0,0-1.35,2.81,2.81,0,0,0-.27-.73,10.44,10.44,0,0,1-3.94,2.05C372,325.14,371.66,325.21,371.66,325.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.39,325l.41.71c2-.57,3.34-1.24,3.8-2a2.81,2.81,0,0,0-.27-.73A10.44,10.44,0,0,1,372.39,325Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.46,327.52c2.14-.6,2.93-1.59,3.16-2.5a7.42,7.42,0,0,0-2.24,1.14A2.71,2.71,0,0,0,373.46,327.52Z",
    style: {
      fill: "#de5753"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 179.8,
    cy: 90.77,
    r: 30.52,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.32,90.77a29.36,29.36,0,0,1-6.14,18,28.81,28.81,0,0,1-3.51,3.82,27.5,27.5,0,0,1-3.79,2.92.45.45,0,0,1-.17.11,27,27,0,0,1-3.28,1.84,29.5,29.5,0,0,1-35.1-7.55h0a29.52,29.52,0,1,1,52-19.12Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.67,90.77c.65-1.44,1.11-.81,3,.64a4.76,4.76,0,0,1,2.17,4.29c0,1.54-.29,4.61-.29,4.61l4.88,5.47-2.21,3.33-5.67-6.4s-2.8-2.11-3.27-4.48S186.67,90.77,186.67,90.77Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,89.13l4,7.18a.86.86,0,0,1-.11,1l-3.1,3.58a.88.88,0,0,1-1.42-.12l-3.58-5.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.8 89.9 189.33 96.55 185.97 100.5 182.36 94.64 185.8 89.9",
    style: {
      fill: "#D2232A",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.88,115.5c0,.15.05.29.07.43l-.24-.32a27,27,0,0,1-3.28,1.84c.26-2,.55-3.86.81-5.39s.44-2.55.6-3.36.25-1.28.27-1.36h0a3.9,3.9,0,0,1,1,.34c1.53.75,3,2.54,4.51,4.91A27.5,27.5,0,0,1,195.88,115.5Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,115.93l-.24-.32a27,27,0,0,1-3.28,1.84,29.5,29.5,0,0,1-35.1-7.55c.51-.12,1-.23,1.55-.33l.16,0,.31-.06c1.35-.26,2.73-.49,4.11-.69h0l1.81-.25c.8-.11,1.6-.2,2.39-.29l.19,0c1.83-.21,3.66-.38,5.44-.51l1.74-.11h0l2.22-.14,2.16-.1.87,0,2.51-.07c2.63-.06,4.94-.06,6.78,0l1.22,0,1.76.05c1,0,1.52,0,1.52,0,.12.44.24.9.35,1.37h0c.51,2,1,4.33,1.42,6.78C195.91,115.65,195.93,115.79,196,115.93Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,115.93l-.24-.32a27,27,0,0,1-3.28,1.84,29.5,29.5,0,0,1-35.1-7.55l-.72.15.71-.16,1.56-.32.16,0,.31-.06c1.35-.26,2.73-.49,4.11-.69h0l1.81-.25c.8-.11,1.6-.2,2.39-.29l.19,0c1.83-.21,3.66-.38,5.44-.51l1.73-.12,2.24-.13,2.16-.1.87,0,2.5-.08c2.64,0,5,0,6.79,0l1.22,0,1.74,0,1.54.06h0c.12.44.24.9.35,1.37h0c.51,2,1,4.33,1.42,6.78C195.91,115.65,195.93,115.79,196,115.93Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.65,108.21c3.24,3,11.2,1.86,11.2,1.86s5-1.36,3.92-2.91c-2.92-.49-4.34-1.85-4.92-3.6a8.55,8.55,0,0,1-.3-3.34,16.9,16.9,0,0,1,.24-1.86L168,91.08C169.25,95.88,170.83,104.72,167.65,108.21Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.23,95.7c.39,5.9,5.24,7.53,7.62,7.86a8.55,8.55,0,0,1-.3-3.34Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.2,77.06s1.4,9.18-3.48,12.71-4.87-13.56-4.87-13.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,97.07a8.33,8.33,0,0,0,9.57,3.23,9.25,9.25,0,0,0,5.3-4.32,8,8,0,0,0,.44-.88c2.4-5.61,3.16-15.43-2.77-19.1a9,9,0,0,0-12.44,2.83,8.92,8.92,0,0,0-1.36,4C167.58,89.36,166.84,93.19,169.57,97.07Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.87,86.31c-.12.52.12,1,.47,1.06s.7-.33.79-.85-.12-1-.46-1.07S178,85.77,177.87,86.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.86,87.33c-.12.52.12,1,.47,1.06s.7-.32.79-.85-.12-1-.46-1.06S184,86.83,183.86,87.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.92,87.27a19.15,19.15,0,0,0,1.75,5,3.08,3.08,0,0,1-2.62,0Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35,84.05a.32.32,0,0,0,.32-.07,2.56,2.56,0,0,1,2.17-.7.31.31,0,0,0,.15-.61h0a3.13,3.13,0,0,0-2.75.85.31.31,0,0,0,0,.44h0A.57.57,0,0,0,176.35,84.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.79,85.7a.29.29,0,0,0,.18,0,.31.31,0,0,0,.22-.39h0a3.12,3.12,0,0,0-1.94-2.13.31.31,0,0,0-.39.21h0a.33.33,0,0,0,.21.39h0a2.55,2.55,0,0,1,1.52,1.71A.31.31,0,0,0,186.79,85.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.47,75.5v2.93A2.17,2.17,0,0,0,173.06,81c.63,2.54-1.21,6.14-3.25,7.42,0,0,.07-1.06-.85-.92s-1.34,5.65.07,8.48c0,0-2.33-2.69-3.11-8.62-.72-5.49-.35-9.94,1-11.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.56,87.65a6.27,6.27,0,0,0,3,3.74c1.94,1,3.39-.58,3.26-2.67-.14-1.85-1.29-4.68-3.44-4.84A2.8,2.8,0,0,0,164.56,87.65Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.47,78.43s1.9,1.89,3.75.51c0,0,2.09,1.74,3.8.5a3.85,3.85,0,0,0,2.47,1.77A1.33,1.33,0,0,0,186,79.82s2.42,1.39,3.32.74-.49-3.25-.49-3.25,1.14-.61.4-2.7S185.14,73,185.14,73s.13-2-2.23-4a2.29,2.29,0,0,0-3.76.49s-2.28-3.09-5.11-2.68-2.5,2.35-2.5,2.35-3.26-2-4.72,0,0,3,0,3-3.25,1.09-3.09,3.31,1.83,1.89,1.83,1.89-.93,1.06,1.18,2,4.1-1.3,4.1-1.3a1.44,1.44,0,0,0,.7,2.12C173.06,81,174.47,78.43,174.47,78.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.91,94.24a18.88,18.88,0,0,0-1.85,2l-.41-.24c-1.88-1.09-2.39-2.21-2.39-3.13a2.79,2.79,0,0,1,.35-1.27A2.68,2.68,0,0,1,177,91a10.24,10.24,0,0,0,3.24,2.89C180.66,94.1,180.91,94.24,180.91,94.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.28,93.86l-.56.57c-1.77-1-2.87-2-3.11-2.84A2.68,2.68,0,0,1,177,91,10.24,10.24,0,0,0,180.28,93.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.65,96c-1.88-1.09-2.39-2.21-2.39-3.13a7.19,7.19,0,0,1,1.85,1.62A2.66,2.66,0,0,1,178.65,96Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85,110.07s-11.47-7.8-15.12-8.23-3,4.11-3,4.11-2.82,0-1.74,3.47,16.67,5.38,22.42,3.66,9.18-4.94,8.23-8-3.62-.43-3.62-.43-1.55-2.87-3.78-2.2S178.85,110.07,178.85,110.07Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.18,108.76a28.81,28.81,0,0,1-3.51,3.82,27.5,27.5,0,0,1-3.79,2.92c0,.15.05.29.07.43l-.24-.32c-.76-1-1.64-2.26-2.47-3.55a21.42,21.42,0,0,1-2.41-4.82h0a5.09,5.09,0,0,1-.24-1.24l-1-1.32.31-.36,2.52-3,.55-.64,1.08,1.41s1.39-.5,5.84,3.33A32.56,32.56,0,0,1,203.18,108.76Z",
    style: {
      fill: "#D2232A"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.44,
    cy: 278.66,
    r: 28.86,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.29,278.66A27.64,27.64,0,0,1,117,296.23a28,28,0,0,1-4,4c-.46.38-.94.75-1.44,1.1a27.09,27.09,0,0,1-4.32,2.55,27.76,27.76,0,0,1-25.9-1.13,26,26,0,0,1-3-2.05h0l-.15-.13a24.73,24.73,0,0,1-3.15-2.9,27.85,27.85,0,1,1,48.21-19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,300.2c-.46.38-.94.75-1.44,1.1a27.09,27.09,0,0,1-4.32,2.55,27.76,27.76,0,0,1-25.9-1.13,26,26,0,0,1-3-2.05h0l-.15-.13,0-.19h0c.24-.9.47-1.84.68-2.82.3-1.32.57-2.69.81-4.12a60.94,60.94,0,0,0,.84-11.78c-.49-14.75,2.19-20.16,8.22-23.05.27-.13.55-.27.85-.39a8.08,8.08,0,0,1,4.25-.53h0c5.16.7,9.64,5.51,9.64,5.51a34,34,0,0,1,2.36,4,66.5,66.5,0,0,1,6.93,25.44h0A75,75,0,0,1,113.08,300.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.87,292.6h0a8.34,8.34,0,0,0-2.91-1.52s-5.88-.57-11-.53l-1.69.08c-2.62.14-5.24.41-7.83.8-.76.11-1.52.23-2.27.37a74.62,74.62,0,0,0-7.41,1.61c-1.17.31-2.33.65-3.49,1a9.53,9.53,0,0,0-1.2,3.22,24.73,24.73,0,0,0,3.15,2.9l.15.13h0a26,26,0,0,0,3,2.05,27.76,27.76,0,0,0,25.9,1.13,27.09,27.09,0,0,0,4.32-2.55c.5-.35,1-.72,1.44-1.1a28,28,0,0,0,4-4A38.25,38.25,0,0,0,112.87,292.6Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.87,292.6h0a8.34,8.34,0,0,0-2.91-1.52s-5.88-.57-11-.53l-1.69.08c-2.62.14-5.24.41-7.83.8-.76.11-1.52.23-2.27.37a74.62,74.62,0,0,0-7.41,1.61c-1.17.31-2.33.65-3.49,1a9.53,9.53,0,0,0-1.2,3.22,24.73,24.73,0,0,0,3.15,2.9l.15.13h0a26,26,0,0,0,3,2.05,27.76,27.76,0,0,0,25.9,1.13,27.09,27.09,0,0,0,4.32-2.55c.5-.35,1-.72,1.44-1.1a28,28,0,0,0,4-4A38.25,38.25,0,0,0,112.87,292.6Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.81,296.35c-6.48-.83-8.42-3.6-8.42-3.6,2.64-2.5,2.16-6.18,1.49-8.47a13.58,13.58,0,0,0-.8-2.12l7.79,1.46a23.1,23.1,0,0,0-.3,3.28,10.51,10.51,0,0,0,.22,2.41c.53,2.33,1.86,2.36,1.86,2.36C100,294.23,96.81,296.35,96.81,296.35Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.57,286.9a10.51,10.51,0,0,0,.22,2.41c-3.09-.41-5.44-2.88-6.91-5a13.58,13.58,0,0,0-.8-2.12l7.79,1.46A23.1,23.1,0,0,0,96.57,286.9Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.29,262c6.78.25,8.82,4,9.06,11,.3,8.75-1.87,14.88-10.28,12.7C82.66,282.74,84,261.61,95.29,262Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,272.46a14.67,14.67,0,0,0,1.87,2.88,1.86,1.86,0,0,1-1.82.7Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,268.33a.32.32,0,0,1-.23-.08.36.36,0,0,1,0-.5,3.84,3.84,0,0,1,3.31-1,.35.35,0,0,1,.29.4.34.34,0,0,1-.41.29,3.22,3.22,0,0,0-2.65.8A.36.36,0,0,1,93,268.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58,268a.39.39,0,0,1-.21-.06,2.84,2.84,0,0,0-2.37-.61.37.37,0,0,1-.44-.23.36.36,0,0,1,.23-.45,3.51,3.51,0,0,1,3,.71.37.37,0,0,1,.08.5A.37.37,0,0,1,103.58,268Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,278.67a17.41,17.41,0,0,0-.88,2.33l-.44-.06c-2-.27-2.78-1.05-3.1-1.83a2.6,2.6,0,0,1-.15-1.2,2.65,2.65,0,0,1,.15-.67,9.47,9.47,0,0,0,3.75,1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.28,278.57l-.28.68c-1.85-.26-3.12-.7-3.62-1.34a2.65,2.65,0,0,1,.15-.67A9.47,9.47,0,0,0,98.28,278.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63,280.94c-2-.27-2.78-1.05-3.1-1.83a6.32,6.32,0,0,1,2.12.74A2.28,2.28,0,0,1,97.63,280.94Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.45,273.18s3.38-5.45,3.06-9.77c0,0,13.64-5,13.79,8.67,0,0,1.77-12.06-9.88-12.76S82.2,275.67,88,281C88,281,85.36,276.59,87.45,273.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.51,274.65a3,3,0,0,0-3.1-2.83c-2.11.15-3.27,4.43,1.91,5.66C88.07,277.65,88.52,276.94,88.51,274.65Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.48,257.55c3.67-1,13.44-1.15,15.75,9l-1.36.68A21.78,21.78,0,0,0,98.54,265a17.57,17.57,0,0,0-1.9-2.72,15.79,15.79,0,0,1,0,2.58s-6.38.94-9.23,3.53c-4.48,4.08-4.76,6.66-4.76,6.66S79.55,260.87,91.48,257.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.18,266.42a.25.25,0,0,1-.23-.17,11.82,11.82,0,0,0-5.9-7.28c-5-2.48-11-.46-11-.44a.24.24,0,1,1-.16-.46c.06,0,6.2-2.1,11.41.46a12.28,12.28,0,0,1,6.14,7.57.24.24,0,0,1-.15.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,271.76s1.59-1.35,2.34.46A4.66,4.66,0,0,0,94,271.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.53,272.76s.88-1.84,2-.54A4.61,4.61,0,0,0,101.53,272.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251.05,
    y: 138.49,
    width: 21.1,
    height: 21.1,
    rx: 3.69,
    transform: "translate(7.42 -12.33) rotate(2.74)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.6,145.17c-1.37-2.48-4.26-1.69-5.82.12-1.38-1.95-4.18-3-5.78-.67-2.71,3.95,2.28,8,4.65,9.57l.68.46.72-.39C264.56,152.9,269.91,149.37,267.6,145.17Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.44,158.06s-3.07,6.19-9.36,7.87c0,0,3.52-1.81,3.57-8.41Z",
    style: {
      fill: "#D2232A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.51,223.32s7.94-7.94,10.49-13.59c0,0-1-3.17-.06-4.8s6.2-6.34,7.61-5.34,3.45,4.94,2.61,6.59-6,5-6,5-6.43,12.9-10.41,15.8S279.51,223.32,279.51,223.32Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.43,199.45c4.62.6,9.9,23,13.59,25.13S286.3,214.3,286.3,214.3l4.39,5S278,237,273,235.38s-14.43-19-14.43-19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.43,199.45c4.62.6,9.9,23,13.59,25.13S286.3,214.3,286.3,214.3l4.39,5S278,237,273,235.38s-14.43-19-14.43-19Z",
    style: {
      fill: "#fff",
      opacity: 0.05,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.49 406.24 281.42 407.32 278.93 399.03 276.65 391.43 283.66 388.99 285.69 398.12 287.49 406.24",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.05,407.16c-.1-.68,8.22-1.6,8.22-1.6s6,4.25,11.09,4.54,2.89,3.72-2.6,4.69l-13.6,2.4C279.26,417.88,281.11,414.13,280.05,407.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.35,406.94a13.15,13.15,0,0,1-3-.48l-.07,0h0a.17.17,0,0,1-.06-.06h0l0-.05h0a.38.38,0,0,1,0-.1c0-.1.37-2.13,1.4-2.79a1.3,1.3,0,0,1,1.07-.16c.41.11.63.31.67.59,0,.44-.46,1-1.07,1.45a3.46,3.46,0,0,1,1.88-.12.86.86,0,0,1,.54.48.81.81,0,0,1,0,.91A1.74,1.74,0,0,1,292.35,406.94Zm-2.25-.75c1.3.3,2.89.48,3.22.1,0,0,.12-.14,0-.45a.52.52,0,0,0-.29-.25A5.52,5.52,0,0,0,290.1,406.19Zm1.21-2.54a.8.8,0,0,0-.46.14,3.75,3.75,0,0,0-1.1,2c1.14-.68,2.2-1.53,2.16-1.9,0-.12-.22-.19-.34-.23A1.15,1.15,0,0,0,291.31,403.65Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.72 398.31 278.96 399.2 276.67 391.52 283.67 389.03 285.72 398.31",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.94 408.85 240.77 408.85 239.76 400.26 238.84 392.38 246.17 391.19 246.58 400.54 246.94 408.85",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.45,408.45c0-.68,8.37-.15,8.37-.15s5.14,5.23,10.14,6.41,2.2,4.17-3.38,4.17H240.77C236.81,418.88,239.29,415.5,239.45,408.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.22,410.44a10.43,10.43,0,0,1-3.46-1.06l-.08-.05h0l0-.05a.25.25,0,0,1,0-.17c0-.08.73-2,1.87-2.5a1.28,1.28,0,0,1,1.08,0c.38.18.56.41.55.7,0,.44-.62.88-1.3,1.24a3.35,3.35,0,0,1,1.87.21.86.86,0,0,1,.45.56.81.81,0,0,1-.2.89A1.2,1.2,0,0,1,252.22,410.44Zm-2.7-1.2c1.23.52,2.76,1,3.16.66,0,0,.13-.11,0-.44a.45.45,0,0,0-.24-.29A5.39,5.39,0,0,0,249.52,409.24Zm1.49-2.3a1,1,0,0,0-.33.07,3.71,3.71,0,0,0-1.44,1.8c1.24-.47,2.44-1.12,2.46-1.5,0-.11-.19-.22-.3-.28A.92.92,0,0,0,251,406.94Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.58 400.73 239.76 400.43 238.84 392.46 246.17 391.23 246.58 400.73",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.3,393.49l-10,1.76c-10.08-25.1-17.24-46.06-22.3-63.45-2.73-9.38-4.85-17.73-6.49-25.13L248,334v62.08H237.84c-24.67-117.63-7.19-144.52-7.19-144.52l29.51-5A133.7,133.7,0,0,1,262.63,263l1.33,9.75,11.54,59.57Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.75 394.02 287.13 389.91 286.96 395.18 276.72 398.44 274.75 394.02",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.51 394.59 249.43 392.7 248.34 397.86 237.69 399.29 236.51 394.59",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5,187.19a.22.22,0,0,1-.13,0c-3.76-2.27-7.12-10.62-7.26-11a.24.24,0,0,1,.14-.32.26.26,0,0,1,.33.14c0,.08,3.43,8.55,7,10.73a.26.26,0,0,1,.09.35A.27.27,0,0,1,257.5,187.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.23,165.25s1.47-5,11.27-5.84,14.67,8.8,12.36,16c0,0,2.06,9.76,6,12.63,0,0-18.86,8.52-28.38,8.57-2.12,0-6.64-10.51-7.23-18.09C220.71,171.2,222.91,165.48,227.23,165.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.65 247.16 230.65 251.56 260.75 249.25 260.75 244.04 230.65 247.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.65 247.16 230.65 251.56 260.75 249.25 260.75 244.04 230.65 247.16",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.42,
    y: 245.4,
    width: 6.61,
    height: 5.01,
    transform: "translate(-21.11 23.35) rotate(-5.12)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.46,
    y: 245.34,
    width: 1.49,
    height: 7.61,
    transform: "translate(-12.41 12.59) rotate(-2.93)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.84,
    y: 243.32,
    width: 1.49,
    height: 7.61,
    transform: "translate(-12.25 13.49) rotate(-2.92)",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.87,244.57l-30.1,2.6c-.29-4.55-.58-8.45-1.27-12.82-.44-2.8-1.05-5.8-1.93-9.29-.68-2.73-1.53-5.77-2.61-9.25-.05-.19-.11-.38-.17-.57-.62-2-5-.47-5.43-2.86-1.74-10.64,9.74-11.42,14-12.12a95.8,95.8,0,0,1,13.52-1.42c5.85-.05,12.58.61,12.58.61s1,.23,1.56,6.44C261.54,211.71,262.08,223.37,260.87,244.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,205.49c-7.41-1-9.64-4.12-9.64-4.12,4.7-4.44.79-12.14.79-12.14l8.93,1.67a27.9,27.9,0,0,0-.35,3.76c-.06,5.42,2.39,5.47,2.39,5.47C248,203.07,244.36,205.49,244.36,205.49Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.44,190.9a27.9,27.9,0,0,0-.35,3.76c-6,0-8.58-5.43-8.58-5.43Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.6,165.91c7.58-1.72,10.94,1.79,13.26,9.48,2.91,9.6,2.31,17-7.64,17.09C229.71,192.56,225,168.76,237.6,165.91Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.86,176.07a16.7,16.7,0,0,0,2.92,2.65A2.14,2.14,0,0,1,247,180Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.08,176.5c.16.62-.05,1.21-.46,1.31s-.88-.31-1-.93,0-1.21.46-1.31S240.93,175.88,241.08,176.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.89,175.64l1.21-.86S240.72,176.08,239.89,175.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.75,174.44c.16.62-.05,1.2-.46,1.31s-.88-.32-1-.94.05-1.2.46-1.3S248.6,173.82,248.75,174.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.56,173.58l1.21-.87S248.39,174,247.56,173.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,173.54a.34.34,0,0,1-.16,0,.36.36,0,0,1-.16-.48,4.37,4.37,0,0,1,3.32-2.1.37.37,0,0,1,.39.33.36.36,0,0,1-.32.4,3.69,3.69,0,0,0-2.74,1.69A.37.37,0,0,1,236.79,173.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.26,170.08a.35.35,0,0,1-.3-.17.37.37,0,0,1,.1-.5,4,4,0,0,1,3.49-.09.36.36,0,1,1-.26.67,3.27,3.27,0,0,0-2.83,0A.36.36,0,0,1,245.26,170.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.55,183.26a19.89,19.89,0,0,0-.29,2.83l-.5.07c-2.25.27-3.39-.34-4-1.11a2.84,2.84,0,0,1-.52-1.29,2.72,2.72,0,0,1,0-.79,10.66,10.66,0,0,0,4.54.37C246.25,183.31,246.55,183.26,246.55,183.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.78,183.34l-.11.83c-2.13.26-3.66.15-4.4-.41a2.72,2.72,0,0,1,0-.79A10.66,10.66,0,0,0,245.78,183.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.76,186.16c-2.25.27-3.39-.34-4-1.11a7.13,7.13,0,0,1,2.57.19A2.69,2.69,0,0,1,245.76,186.16Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,180.56s2.14-7,.51-11.71c0,0,13.64-9.55,17.83,5.54,0,0-1.6-13.88-14.7-11.23s-8.73,21.71-.71,25.86C235.13,189,230.89,185,232.2,180.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.81,181.88a3.41,3.41,0,0,0-4.27-2.22c-2.29.78-2.32,5.86,3.78,5.7C234.2,185.33,234.49,184.41,233.81,181.88Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.71,168.85s7.86-2.9,12.28-.72c0,0-4.76-4.28-12.84-.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.84,202.19s8.71,7.07,16.82,6.95,11-9.23,11-9.23S243,196.19,227.84,202.19Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,331.8c-2.73-9.38-4.85-17.73-6.49-25.13a232.53,232.53,0,0,1,1.91-26.21S253.75,314.27,254,331.8Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.47,217.85s-6-9.52-7.2-15.6c0,0,1.65-2.87,1.13-4.66s-4.63-7.56-6.22-6.9-4.47,4-4,5.84,4.76,6.25,4.76,6.25,3.39,14,6.62,17.72S203.47,217.85,203.47,217.85Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.72,207.17c3-.42,9.16,5.5,8.23,10.62s-9.51,19.52-16.13,18.4C202.47,234.6,192.2,210,192.2,210l5.13-4.47s12.11,21,14.49,20.56S219.72,207.17,219.72,207.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.72,207.17c3-.42,9.16,5.5,8.23,10.62s-9.51,19.52-16.13,18.4C202.47,234.6,192.2,210,192.2,210l5.13-4.47s12.11,21,14.49,20.56S219.72,207.17,219.72,207.17Z",
    style: {
      fill: "#fff",
      opacity: 0.05,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.1 208.45 197.59 203.96 198.78 205.9 191.71 212.15 190.1 208.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.63 214.16 290.69 221.67 291.75 219.32 286.3 212.98 284.63 214.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.66,204l9.58-11.68a.91.91,0,0,1,1.32-.08l4.27,4a.9.9,0,0,1,.08,1.23l-9.73,11.94a.9.9,0,0,1-1.35.06l-4.13-4.3A.91.91,0,0,1,287.66,204Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.66,204l9.58-11.68a.91.91,0,0,1,1.32-.08l4.27,4a.9.9,0,0,1,.08,1.23l-9.73,11.94a.9.9,0,0,1-1.35.06l-4.13-4.3A.91.91,0,0,1,287.66,204Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.27,203.54l9.59-11.68a.91.91,0,0,1,1.32-.08l4.27,4a.91.91,0,0,1,.08,1.23l-9.73,12a.91.91,0,0,1-1.36,0l-4.12-4.3A.9.9,0,0,1,287.27,203.54Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.24 192.33 301.98 196.92 292.71 208.32 288.1 203.48 297.24 192.33",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout2);
export default __webpack_public_path__ + "static/media/about2.34d045a707d872d42a53dc58753cc221.svg";
export { ForwardRef as ReactComponent };